import React, { FC } from "react";

import { Heading, Button } from "@telia/teddy";
import { VerificationTarget } from "../../../../../../constants";
import { VerificationDeliveryMethod, VERIFICATION_DELIVERY_METHOD } from "../../../consts";
import TEXT from "../../../text-consts";
import "./Verification.less";

interface ChooseVerificationMethodProps {
    isExistingMissingEmail: boolean;
    isExistingPrepaidKBDSubscription: boolean;
    isSubscriptionBroadband: boolean;
    maskedEmail: string;
    method: VerificationDeliveryMethod;
    onChangeVerificationMethod: (method: VerificationDeliveryMethod) => void;
    onSendCode: (method: VerificationDeliveryMethod, target: VerificationTarget) => void;
    supportsEmailVerification: boolean;
    target: VerificationTarget;
}

const ChooseVerificationMethod: FC<ChooseVerificationMethodProps> = (props) => {
    const {
        method,
        isSubscriptionBroadband,
        isExistingPrepaidKBDSubscription,
        supportsEmailVerification,
        maskedEmail,
        isExistingMissingEmail,
        onSendCode,
        onChangeVerificationMethod,
        target,
    } = props;

    return (
        <div className="verification-container">
            <Heading mb="100" as="h2" variant="title-200">
                {TEXT.PERSONAL_DETAILS.VERIFICATION.HEADING}
            </Heading>
            {method === VERIFICATION_DELIVERY_METHOD.SMS && (
                <div className="verification-container__section">
                    {!isSubscriptionBroadband && (
                        <>
                            <span>{TEXT.PERSONAL_DETAILS.VERIFICATION.DESCRIPTION}</span>
                            <Button
                                className="spacer-top"
                                id="verification-send-sms-button"
                                onClick={() => onSendCode(method, target)}
                                size="sm"
                                variant="secondary"
                            >
                                {TEXT.PERSONAL_DETAILS.VERIFICATION.SEND_SMS}
                            </Button>
                        </>
                    )}
                    {!isExistingMissingEmail && !isExistingPrepaidKBDSubscription && supportsEmailVerification && (
                        <Button
                            className="verification-container__choose-method-link"
                            onClick={() => onChangeVerificationMethod(VERIFICATION_DELIVERY_METHOD.EMAIL)}
                            variant="text-underline"
                            size="sm"
                        >
                            {TEXT.PERSONAL_DETAILS.VERIFICATION.WITH_EMAIL}
                        </Button>
                    )}
                </div>
            )}
            {method === VERIFICATION_DELIVERY_METHOD.EMAIL && (
                <div className="verification-container__section">
                    <>
                        <span>{TEXT.PERSONAL_DETAILS.VERIFICATION.DESCRIPTION}</span>
                        <div>
                            <Button
                                className="spacer-top"
                                id="verification-send-email-button"
                                onClick={() => onSendCode(method, target)}
                                size="sm"
                                variant="secondary"
                            >
                                {TEXT.PERSONAL_DETAILS.VERIFICATION.SEND_EMAIL}
                            </Button>
                            <span className="verification-container__masked-email">{maskedEmail}</span>
                        </div>
                    </>

                    {!isSubscriptionBroadband && (
                        <Button
                            className="verification-container__choose-method-link"
                            onClick={() => onChangeVerificationMethod(VERIFICATION_DELIVERY_METHOD.SMS)}
                            variant="text-underline"
                            size="sm"
                        >
                            {TEXT.PERSONAL_DETAILS.VERIFICATION.WITH_SMS}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

export default ChooseVerificationMethod;
